import {History24Regular} from "@fluentui/react-icons";
import {FC} from "react";
import {HistoryGroup, PromptHistoryItem} from "./intelligenceModels";

interface IntelligenceHistoryViewProps {
    items: PromptHistoryItem[];
    onSelect: (item: PromptHistoryItem) => void;
}

const GROUP_ORDER: HistoryGroup[] = ["Today", "Yesterday", "Last 7 days"];

const IntelligenceHistoryView: FC<IntelligenceHistoryViewProps> = ({
    items,
    onSelect
}) => (
    <div className="pi-scroll">
        <div className="pi-view-head">
            <h2 className="pi-view-head__title">Prompt history</h2>
            <p className="pi-view-head__desc">
                Pick up any conversation where you left off.
            </p>
        </div>

        {GROUP_ORDER.map((group) => {
            const groupItems = items.filter((item) => item.group === group);
            if (groupItems.length === 0) {
                return null;
            }

            return (
                <div className="pi-history__group" key={group}>
                    <div className="pi-history__group-label">{group}</div>
                    {groupItems.map((item) => (
                        <button
                            type="button"
                            key={item.id}
                            className="pi-history-item"
                            onClick={() => onSelect(item)}
                        >
                            <span className="pi-history-item__icon">
                                <History24Regular />
                            </span>
                            <span className="pi-history-item__body">
                                <span className="pi-history-item__title">
                                    {item.title}
                                </span>
                                <span className="pi-history-item__preview">
                                    {item.preview}
                                </span>
                            </span>
                            <span className="pi-history-item__time">
                                {item.timestamp}
                            </span>
                        </button>
                    ))}
                </div>
            );
        })}
    </div>
);

export default IntelligenceHistoryView;
